import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getAppList } from "@/api/app";
export default {
  name: "AppSelect",
  props: {
    value: {
      default: 0
    },
    data_no_all: {
      default: 1
    },
    multiple: {
      default: false
    }
  },
  data: function data() {
    return {
      app_id: this.value,
      appList: {}
    };
  },
  watch: {
    value: {
      handler: function handler(val) {
        this.app_id = val;
      }
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            data = {
              data_no_all: _this.data_no_all
            };
            _context.next = 3;
            return getAppList(data);
          case 3:
            res = _context.sent;
            if (res.code == 0) {
              _this.appList = res.data.list;
            }
            if (_this.app_id != "") {
              _this.selectApp();
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    selectApp: function selectApp() {
      this.$emit("input", this.app_id);
      this.$emit("change", this.app_id);
    }
  }
};